<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
	<rect x="7" y="1" width="2" height="2" />
	<rect x="13" y="4" width="2" height="2" />
	<rect x="13" y="7" width="2" height="2" />
	<rect x="13" y="10" width="2" height="2" />
	<rect x="7" y="13" width="2" height="2" />
	<rect x="10" y="13" width="2" height="2" />
	<rect x="4" y="13" width="2" height="2" />
	<rect x="1" y="10" width="2" height="2" />
	<rect x="1" y="7" width="2" height="2" />
	<rect x="1" y="4" width="2" height="2" />
	<rect x="4" y="1" width="2" height="2" />
	<rect x="10" y="10" width="2" height="2" />
	<rect x="4" y="10" width="2" height="2" />
	<rect x="7" y="10" width="2" height="2" />
	<rect x="10" y="7" width="2" height="2" />
	<rect x="4" y="7" width="2" height="2" />
	<rect x="7" y="7" width="2" height="2" />
	<rect x="10" y="4" width="2" height="2" />
	<rect x="4" y="4" width="2" height="2" />
	<rect x="7" y="4" width="2" height="2" />
	<rect x="10" y="1" width="2" height="2" />
</svg>
</template>